<template>
  <div class="reviews-wrapper">
    <div :class="`elfsight-app-${widgetId}`" data-elfsight-app-lazy></div>
  </div>
</template>

<script>
export default {
  name: 'GoogleReviews',
  props: {
    widgetId: {
      type: String,
      default: 'e604de7c-3441-4778-8d5c-15c954e93be4'
    }
  },
  mounted() {
    if (!document.querySelector('script[src="https://elfsightcdn.com/platform.js"]')) {
      const script = document.createElement('script')
      script.src = 'https://elfsightcdn.com/platform.js'
      script.async = true
      document.body.appendChild(script)
    }
  }
}
</script>

<style scoped lang="scss">
.reviews-wrapper {
  margin: 40px 0;
  padding: 0 20px;
}
</style>